function Features() {
  return (
    <div>
      <h1>heyyyy !</h1>
    </div>
  );
}

export default Features;
